import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { getAllData } from "../../Utility/API";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import { ErrorToast } from "../../components/Toast/message";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const TABS = [
  { key: "source", label: "By Source" },
  { key: "campaign", label: "Campaign Breakdown" },
  { key: "all", label: "All Parameters" },
];

const UtmReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("source");
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState({
    totalVisitors: 0,
    totalSignups: 0,
    totalLoginTouches: 0,
  });
  const [campaignRows, setCampaignRows] = useState([]);
  const [fullRows, setFullRows] = useState([]);

  const fetchReports = async () => {
    setIsLoading(true);
    try {
      const signupResp = await getAllData(`${endPoints.api.UTM_SIGNUPS_REPORT}`);
      const revenueResp = await getAllData(`${endPoints.api.UTM_REVENUE_REPORT}`);
      const summaryResp = await getAllData(`${endPoints.api.UTM_SUMMARY_REPORT}`);
      const campaignResp = await getAllData(`${endPoints.api.UTM_CAMPAIGN_REPORT}`);
      const fullResp = await getAllData(`${endPoints.api.UTM_FULL_REPORT}`);

      if (campaignResp?.status === "success") {
        setCampaignRows(campaignResp.data || []);
      }

      if (fullResp?.status === "success") {
        setFullRows(fullResp.data || []);
      }

      if (summaryResp?.status === "success" && summaryResp.data) {
        setSummary({
          totalVisitors: summaryResp.data.totalVisitors || 0,
          totalSignups: summaryResp.data.totalSignups || 0,
          totalLoginTouches: summaryResp.data.totalLoginTouches || 0,
        });
      }

      if (signupResp?.status !== "success" || revenueResp?.status !== "success") {
        ErrorToast("Unable to load UTM report");
        setRows([]);
        return;
      }

      // merge both reports into one row per source
      const merged = {};
      (signupResp.data || []).forEach((r) => {
        const key = r.source || "";
        merged[key] = {
          source: key,
          totalVisitors: r.totalVisitors || 0,
          totalUsers: r.totalUsers || 0,
          totalLoginTouches: r.totalLoginTouches || 0,
          totalPurchase: 0,
        };
      });
      (revenueResp.data || []).forEach((r) => {
        const key = r.source || "";
        if (!merged[key]) {
          merged[key] = {
            source: key,
            totalVisitors: 0,
            totalUsers: 0,
            totalLoginTouches: 0,
            totalPurchase: 0,
          };
        }
        merged[key].totalPurchase = r.revenue || 0;
      });
      setRows(Object.values(merged));
    } catch (error) {
      ErrorToast("Unable to load UTM report");
      setRows([]);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchReports();
  }, []);

  const conversionRate = (visitors, signups, loginTouches) => {
    const newVisitors = (visitors || 0) - (loginTouches || 0);
    if (newVisitors <= 0) return "-";
    return (((signups || 0) / newVisitors) * 100).toFixed(1) + "%";
  };

    const sumBy = (list, key) =>
    (list || []).reduce((acc, r) => acc + Number(r[key] || 0), 0);

  const shareOfTotal = (amount, total) => {
    const value = Number(amount || 0);
    if (!total) return "-";
    return ((value / total) * 100).toFixed(1) + "%";
  };

  const sourceRevenueTotal = sumBy(rows, "totalPurchase");
  const campaignRevenueTotal = sumBy(campaignRows, "revenue");
  const fullRevenueTotal = sumBy(fullRows, "revenue");

  const displaySource = (source) =>
    source && source !== "" ? source : "(unknown)";

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <div className="row">
                <div
                  className="col-md-12"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #444",
                  }}
                >
                  <h3
                    className="mb-2"
                    style={{ fontFamily: "ArticulatCF-Bold" }}
                  >
                    UTM Marketing Report
                  </h3>
                </div>
              </div>

              <div className="row" style={{ padding: "15px 0px 5px 0px" }}>
                <div className="col-md-3">
                  <div className="card-box" style={{ textAlign: "center", padding: "15px" }}>
                    <h5 style={{ margin: 0 }}>Total Visitors</h5>
                    <h2 style={{ margin: "8px 0 0 0" }}>{summary.totalVisitors}</h2>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card-box" style={{ textAlign: "center", padding: "15px" }}>
                    <h5 style={{ margin: 0 }}>Total Signups</h5>
                    <h2 style={{ margin: "8px 0 0 0" }}>{summary.totalSignups}</h2>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card-box" style={{ textAlign: "center", padding: "15px" }}>
                    <h5 style={{ margin: 0 }}>Returning via Campaign</h5>
                    <h2 style={{ margin: "8px 0 0 0" }}>{summary.totalLoginTouches}</h2>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="card-box" style={{ textAlign: "center", padding: "15px" }}>
                    <h5 style={{ margin: 0 }}>Signups / Visitor</h5>
                    <h2 style={{ margin: "8px 0 0 0" }}>
                      {conversionRate(
                        summary.totalVisitors,
                        summary.totalSignups,
                        summary.totalLoginTouches
                      )}
                    </h2>
                  </div>
                </div>
              </div>

              <div className="container-fluid table-custom">
                <div className="row" style={{ padding: "5px 0px 20px 0px" }}>
                  {/* left tab rail: click a label to switch the table on the right */}
                  <div className="col-md-3">
                    <Paper sx={{ overflow: "hidden" }}>
                      {TABS.map((tab) => (
                        <div
                          key={tab.key}
                          onClick={() => setActiveTab(tab.key)}
                          style={{
                            padding: "14px 16px",
                            cursor: "pointer",
                            borderLeft:
                              activeTab === tab.key
                                ? "4px solid #1976d2"
                                : "4px solid transparent",
                            background:
                              activeTab === tab.key
                                ? "rgba(25, 118, 210, 0.12)"
                                : "transparent",
                            fontWeight: activeTab === tab.key ? "bold" : "normal",
                          }}
                        >
                          {tab.label}
                        </div>
                      ))}
                    </Paper>
                  </div>

                  <div className="col-md-9">
                    {activeTab === "source" && (
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        aria-label="utm report by source"
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Source</TableCell>
                            <TableCell align="center">Visitors</TableCell>
                            <TableCell align="center">Signups</TableCell>
                            <TableCell align="center">Returning</TableCell>
                            <TableCell align="center">Signups / Visitor</TableCell>
                            <TableCell align="center">Total Purchase</TableCell>
                            <TableCell align="center">Purchase %</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.length === 0 ? (
                            <TableRow>
                              <TableCell align="center" colSpan={7}>
                                No data
                              </TableCell>
                            </TableRow>
                          ) : (
                            rows.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell align="center">
                                  {displaySource(row.source)}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalVisitors}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalUsers}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalLoginTouches || 0}
                                </TableCell>
                                <TableCell align="center">
                                  {conversionRate(
                                    row.totalVisitors,
                                    row.totalUsers,
                                    row.totalLoginTouches
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  {Number(row.totalPurchase || 0).toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  {shareOfTotal(row.totalPurchase, sourceRevenueTotal)}
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    )}

                    {activeTab === "campaign" && (
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        aria-label="utm report by campaign and source"
                        sx={{ minWidth: 500 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Campaign</TableCell>
                            <TableCell align="center">Source</TableCell>
                            <TableCell align="center">Visitors</TableCell>
                            <TableCell align="center">Signups</TableCell>
                            <TableCell align="center">Returning</TableCell>
                            <TableCell align="center">Signups / Visitor</TableCell>
                            <TableCell align="center">Total Purchase</TableCell>
                            <TableCell align="center">Purchase %</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {campaignRows.length === 0 ? (
                            <TableRow>
                              <TableCell align="center" colSpan={8}>
                                No data
                              </TableCell>
                            </TableRow>
                          ) : (
                            campaignRows.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell align="center">
                                  {row.campaign && row.campaign !== "" ? row.campaign : "(unknown)"}
                                </TableCell>
                                <TableCell align="center">
                                  {displaySource(row.source)}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalVisitors}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalUsers}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalLoginTouches || 0}
                                </TableCell>
                                <TableCell align="center">
                                  {conversionRate(
                                    row.totalVisitors,
                                    row.totalUsers,
                                    row.totalLoginTouches
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  {Number(row.revenue || 0).toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  {shareOfTotal(row.revenue, campaignRevenueTotal)}
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    )}

                    {activeTab === "all" && (
                    <TableContainer component={Paper}>
                      <Table
                        className="c_table"
                        size="small"
                        stickyHeader
                        aria-label="utm report by all parameters"
                        sx={{ minWidth: 700 }}
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">Source</TableCell>
                            <TableCell align="center">Medium</TableCell>
                            <TableCell align="center">Campaign</TableCell>
                            <TableCell align="center">Content</TableCell>
                            <TableCell align="center">Visitors</TableCell>
                            <TableCell align="center">Signups</TableCell>
                            <TableCell align="center">Returning</TableCell>
                            <TableCell align="center">Signups / Visitor</TableCell>
                            <TableCell align="center">Total Purchase</TableCell>
                            <TableCell align="center">Purchase %</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {fullRows.length === 0 ? (
                            <TableRow>
                              <TableCell align="center" colSpan={10}>
                                No data
                              </TableCell>
                            </TableRow>
                          ) : (
                            fullRows.map((row, index) => (
                              <TableRow key={index}>
                                <TableCell align="center">
                                  {displaySource(row.source)}
                                </TableCell>
                                <TableCell align="center">
                                  {displaySource(row.medium)}
                                </TableCell>
                                <TableCell align="center">
                                  {displaySource(row.campaign)}
                                </TableCell>
                                <TableCell align="center">
                                  {displaySource(row.content)}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalVisitors}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalUsers}
                                </TableCell>
                                <TableCell align="center">
                                  {row.totalLoginTouches || 0}
                                </TableCell>
                                <TableCell align="center">
                                  {conversionRate(
                                    row.totalVisitors,
                                    row.totalUsers,
                                    row.totalLoginTouches
                                  )}
                                </TableCell>
                                <TableCell align="center">
                                  {Number(row.revenue || 0).toFixed(2)}
                                </TableCell>
                                <TableCell align="center">
                                  {shareOfTotal(row.revenue, fullRevenueTotal)}
                                </TableCell>
                              </TableRow>
                            ))
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    )}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UtmReport;
